import(/* webpackMode: "eager" */ "/vercel/path0/app/earn/page.tsx");
